module.exports = __webpack_public_path__ + "static/media/epubupload.46c39448.svg";